<template>
  <div>
    <v-dialog v-model="showDialog" scrollable max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn color="#004884" dark @click="openDialog" outline block small>{{ 'BUTTON_WZ_CODE_OPEN' | translate}}
        </v-btn>
      </template>
      <v-card>
        <v-card color="#004884" dark>
          <v-card-title>{{ 'DIALOG_WZ_CODE_TITLE' | translate}}</v-card-title>
        </v-card>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-layout row wrap justify-space-between>
            <v-flex xs12 sm6>
              <v-select v-model="wzcodeselect"
                        item-text="Bezeichnung"
                        return-object
                        @change="onChangeBereich"
                        :items="wzcodeGroups"
                        class="ma-2"
                        :label="labelwzcodeselect"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                class="ma-2"
                v-model="search"
                :label="labelwzcode"
                hide-details
                clearable
                append-icon="search"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-start :key="tvIndex">
            <v-treeview
              active-class="activetree"
              :active.sync="active"
              :items="wzcode"
              :search="search"
              ref="treeview"
              open-all
              :filter="filter"
              :open.sync="open"
            >
              <template v-slot:label="{ item, leaf, selected,indeterminate, active, open }" class="text-xs-left">
                <span v-if="item" @click="openItem(item)">{{item.name}}</span>
                <!--
                <span v-if="item && item.meta">{{item.meta.WZCode}}</span> -
                -->
              </template>
              <!--
              <template v-slot:prepend="{ item }">
                <v-icon
                  v-if="item.children"
                  v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"
                ></v-icon>
              </template>

              -->
            </v-treeview>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="#004884" outline small class="text-none" @click="showDialog = false">{{ 'BUTT_CANCEL' |
            translate}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#004884" dark small class="text-none" @click="showDialog = false">{{ 'BUTT_OK' | translate}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  //import Vue from 'vue'
  import Vue from "vue";

  export default {
    name: 'DialogWZCode',
    components: {},
    data() {
      return {
        showDialog: false,
        tvIndex: 0,
        wzcodeselect: {},
        labelwzcodeselect: Vue.i18n.translate('LABEL_WZ_CODE_SELECT'),
        search: '',
        labelwzcode: Vue.i18n.translate('LABEL_WZ_CODE'),
        active: [],
        wzcode: [
          {
            id: 1,
            name: '',
            children: []
          }
        ],
        open: [1, 2],
        wzcodeGroups: []
      }
    },
    computed: {
      filter() {
        return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
      }
    },
    methods: {
      onChangeBereich: function () {
        // console.log('onChangeBereich', this.wzcodeselect)
        let cmp = this
        Vue.prototype.$api.showIdle()
        Vue.prototype.$api.getWZCodeData({WZBereich: this.wzcodeselect.WZBereich, WZCodeArtNr: this.wzcodeselect.WZCodeArtNr}, function (data) {
          Vue.prototype.$api.hideIdle()
          cmp.wzcode = data.children
          cmp.tvIndex++
        })

      },
      openDialog: function () {
        this.showDialog = true
        console.log(this.wzcode)
        this.wzcodeGroups = Vue.prototype.storage.getWZCodeGroups()
        let cmp = this

        if ((!this.wzcodeGroups) || (this.wzcodeGroups.length === 0)) {
          Vue.prototype.$api.showIdle()
          Vue.prototype.$api.getWZCodeGroups(function (data) {
            Vue.prototype.$api.hideIdle()
            Vue.prototype.storage.setWZCodeGroups(data)
            cmp.wzcodeGroups = data
            // cmp.onChangeBereich(cmp.wzcodeGroups[0])
          })
        } else {
          // cmp.onChangeBereich(cmp.wzcodeGroups[0])
        }
        this.$nextTick(function () {
          cmp.$refs['treeview'].updateAll(true)
        })
      },
      openItem: function(item) {
        console.log(item)
        let entry = item
        this.$emit('open', entry.meta)
        this.showDialog = false
      }
    },
    mounted() {
      //   Vue.prototype.$api.checkCredentials(this)
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/module/dialogs/DialogWZCode.vue